/* eslint-disable */
import { useMemo } from 'react';

import { skipToken } from '@reduxjs/toolkit/query';

import { useGetPoliciesQuery, useGetProductStatusDefinitionQuery } from '../store/policiesSlice';
import { PolicyWithStatusDefinition } from '../models/policy';

/**
 * Custom hook that retrieves the customer's policies together with their respective products'
 * status definitions.
 */
export function useGetPoliciesWithStatusDefinitionsQuery() {
  const { data: policies } = useGetPoliciesQuery();
  // Subsequent queries to fire only after the first has retrieved its data
  const { data: statusDefinitions1, isLoading: isLoading1 } = useGetProductStatusDefinitionQuery((policies &&
    policies[0]?.productVersionCode
  ) ?? skipToken);
  const { data: statusDefinitions2, isLoading: isLoading2 } = useGetProductStatusDefinitionQuery((policies &&
    policies[1]?.productVersionCode
  ) ?? skipToken);

  // Most important to use `useMemo` to ensure that React does not re-render
  const policiesWithStatusDefinitionsMemo: PolicyWithStatusDefinition[] | undefined = useMemo(() => {
    let policiesWithStatusDefinitions: PolicyWithStatusDefinition[] = [];
    if (policies) {
      if (statusDefinitions1) policiesWithStatusDefinitions.push(new PolicyWithStatusDefinition(policies[0], statusDefinitions1));
      if (statusDefinitions2) policiesWithStatusDefinitions.push(new PolicyWithStatusDefinition(policies[1], statusDefinitions2));
    }
    return policiesWithStatusDefinitions;
  }, [statusDefinitions1, statusDefinitions2]);

  return {
    data: policiesWithStatusDefinitionsMemo,
    isLoading: isLoading1 || isLoading2
  };
}